import { Molecule, Wrapper, wrap } from "AppReact";
import styled from "styled-components";
import { Badge } from "./atoms";
import { Text } from "atoms";

const template = styled.div``;

export default Molecule({
    template,
    atoms: [
        {
            wrapper: Wrapper(styled.div`display: flex;`),
            name: 'Label',
            atoms: [
                {
                    component: Text,
                    name: "Description",
                    displayValue: ({ text, badgeText }) => text,
                },
                {
                    component: wrap(Badge, Wrapper(styled.div`margin: 0px 5px;`)),
                    name: "Badge",
                    displayValue: ({ text, badgeText }) => badgeText,
                }
            ]
        },
    ]
})
